"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Quote = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styles = require("./styles");
var _bricksTheme = _interopRequireDefault(require("@titelmedia/bricks-theme"));
var _bricksUtils = require("@titelmedia/bricks-utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const Quote = ({
  text,
  fontColor,
  fontWeight,
  lineWidth,
  enableAnimation,
  setAnimationDuration = 0.75
}) => {
  const wrapperRef = (0, _react.useRef)(null);
  const quoteRef = (0, _react.useRef)(null);
  const isAnimationEnable = enableAnimation === 'true' || enableAnimation === true;
  (0, _react.useEffect)(() => {
    if (!quoteRef.current || !isAnimationEnable) return;
    let fadeAnimation = _bricksUtils.gsap.effects.fade(quoteRef.current, {
      duration: setAnimationDuration,
      trigger: wrapperRef.current
    });
    return () => {
      if (fadeAnimation) fadeAnimation.kill();
    };
  }, [isAnimationEnable, setAnimationDuration]);
  return _react.default.createElement(_styles.Container, {
    ref: wrapperRef,
    lineWidth: lineWidth
  }, _react.default.createElement(_bricksTheme.default, null), _react.default.createElement(_styles.Content, null, _react.default.createElement(_styles.QuoteText, {
    ref: quoteRef,
    fontColor: fontColor?.hex || fontColor,
    fontWeight: fontWeight,
    dangerouslySetInnerHTML: {
      __html: text
    }
  })));
};
exports.Quote = Quote;
//# sourceMappingURL=index.js.map